export default "__VITE_ASSET__CPP91eLF__"